import { render, staticRenderFns } from "./FeedbackReasonCard.vue?vue&type=template&id=05783fd8&scoped=true&"
import script from "./FeedbackReasonCard.vue?vue&type=script&lang=js&"
export * from "./FeedbackReasonCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05783fd8",
  null
  
)

export default component.exports